<template>
  <div>
    <div class="dropdown">
      <b-spinner
        v-if="toggleLoadingActionsV2"
        variant="success"
        label="Spinning"
      ></b-spinner>
      <i
        v-else
        class="fa fa-ellipsis-v btn-edit"
        @click="funCclickShowHide()"
      ></i>
      <div
        class="dropdown-child"
        style="line-height: 0.8"
        v-show="clickShowHide"
      >
      <span header="Notificações">
          <header
            id="_bv_dropdown-group-1_group_dd_header"
            class="dropdown-header"
          >
            Notificações
          </header>
          <a
            id="id-do-elemento"
            href="#"
            @click="optionStatusEntregue('resendnotifications')"
          >
            Reenviar
          </a>
        </span>
        <hr
          role="separator"
          aria-orientation="horizontal"
          class="dropdown-divider"
        />
        <span>
          <header
            id="_bv_dropdown-group-1_group_dd_header"
            class="dropdown-header"
          >
            Exportação
          </header>
          <a
            id="id-do-elemento"
            href="#"
            @click="optionStatusEntregue('exportAllOrders')"
          >
            Exportar todos os pedidos
          </a>
          <a
            id="id-do-elemento"
            href="#"
            @click="optionStatusEntregue('exportAllOrdersFiltered')"
          >
            Exportar pedidos filtrados
          </a>
          <a
            id="id-do-elemento"
            href="#"
            @click="optionStatusEntregue('exportAllOrdersSelected')"
          >
            Exportar pedidos selecionados
          </a>
          <a
            id="id-do-elemento"
            href="#"
            @click="optionStatusEntregue('exportModel')"
          >
            Exportar planilha de entrega pedidos selecionados
          </a>
          <a
            id="id-do-elemento"
            href="#"
            @click="optionStatusEntregue('exportModelFiltered')"
          >
            Exportar planilha de entrega pedidos filtrados
          </a>
          <a id="id-do-elemento" href="#" @click="optionStatusEntregue('action_print_filter')">
            Exportar etiquetas para os pedidos filtrados
          </a>
        </span>
        <hr
          role="separator"
          aria-orientation="horizontal"
          class="dropdown-divider"
        />
        <span>
          <header
            id="_bv_dropdown-group-1_group_dd_header"
            class="dropdown-header"
          >
            Documentos
          </header>
          <a
            id="id-do-elemento"
            v-if="
              filters.status == 'invoiced' &&
              filters.sub_status == 'waiting_expedition'
            "
            href="#"
            @click="optionStatusEntregue('action_print_all')"
          >
            Imprimir tudo
          </a>
          <a
            id="id-do-elemento"
            href="#"
            @click="optionStatusEntregue('action_print_notas_fiscais_all')"
          >
            Imprimir etiqueta e DANFE simplificada selecionadas
          </a>
          <a
            id="id-do-elemento"
            v-if="
              filters.status == 'invoiced' &&
              filters.sub_status == 'waiting_expedition'
            "
            href="#"
            @click="optionStatusEntregue('action_print_gnre')"
          >
            Imprimir GNRE
          </a>
          <a
            id="id-do-elemento"
            href="#"
            @click="optionStatusEntregue('action_print_header_pdf')"
          >
            Imprimir cabeçalhos
          </a>
          <a
            id="id-do-elemento"
            href="#"
            @click="optionStatusEntregue('action_print_labels')"
          >
            Imprimir etiquetas
          </a>

          <a
            id="id-do-elemento"
            v-if="filters.status == 'approved'"
            href="#"
            @click="optionStatusEntregue('action_processing_picking')"
          >
            Imprimir lista de picking
          </a>
          <hr
            role="separator"
            aria-orientation="horizontal"
            class="dropdown-divider"
          />
          <a
            id="id-do-elemento"
            href="#"
            @click="optionStatusEntregue('action_generate_labels')"
          >
            Gerar etiquetas selecionadas
          </a>
          <a
            id="id-do-elemento"
            href="#"
            @click="optionStatusEntregue('action_create_plp')"
          >
            Gerar PLP
          </a>
        </span>
        <hr
          role="separator"
          aria-orientation="horizontal"
          class="dropdown-divider"
        />
        <span header="Status">
          <header
            id="_bv_dropdown-group-1_group_dd_header"
            class="dropdown-header"
          >
            Status
          </header>
          <a
            id="id-do-elemento"
            v-if="
              filters.status == 'picking' &&
              filters.sub_status == 'processing_picking'
            "
            href="#"
            @click="optionStatusEntregue('action_sigep')"
          >
            Enviar por SIGEP WEB
          </a>
          <a
            id="id-do-elemento"
            v-if="
              filters.status == 'picking' &&
              filters.sub_status == 'processing_picking'
            "
            href="#"
            @click="optionStatusEntregue('action_pending_invoice')"
          >
            Marcar como separado
          </a>
          <a
            id="id-do-elemento"
            v-if="
              filters.status == 'picking' &&
              filters.sub_status == 'pending_invoice'
            "
            href="#"
            @click="optionStatusEntregue('action_waiting_invoice')"
          >
            Gerar nota fiscal
          </a>
          <a
            id="id-do-elemento"
            v-if="
              filters.status == 'invoiced' &&
              filters.sub_status == 'waiting_expedition'
            "
            href="#"
            @click="optionStatusEntregue('action_print_nfe')"
          >
            Baixar PDF notas fiscais
          </a>
          <a
            id="id-do-elemento"
            v-if="
              filters.status == 'invoiced' &&
              filters.sub_status == 'waiting_expedition'
            "
            href="#"
            @click="optionStatusEntregue('action_print_xlsx_nfe')"
          >
            Baixar XLSX das notas fiscais
          </a>
          <a
            id="id-do-elemento"
            v-if="
              filters.status == 'invoiced' &&
              filters.sub_status == 'waiting_expedition'
            "
            href="#"
            @click="optionStatusEntregue('action_processing_expedition')"
          >
            Marcar como embalado
          </a>
          <a
            id="id-do-elemento"
            v-if="
              filters.status == 'invoiced' &&
              filters.sub_status == 'processing_expedition'
            "
            href="#"
            @click="optionStatusEntregue('action_dispatched')"
          >
            Marcar como enviado
          </a>

          <a
            id="id-do-elemento"
            href="#"
            @click="optionStatusEntregue('picking')"
          >
            Alterar status para disponível para retirada
          </a>
          <a
            id="id-do-elemento"
            href="#"
            @click="optionStatusEntregue('delivered')"
          >
            Alterar status para entregue (status final)
          </a>
          <a
            id="id-do-elemento"
            href="#"
            @click="optionStatusEntregue('canceled')"
          >
            Alterar status para cancelado (status final)
          </a>
        </span>
        <hr
          role="separator"
          aria-orientation="horizontal"
          class="dropdown-divider"
        />
        <hr
          role="separator"
          aria-orientation="horizontal"
          class="dropdown-divider"
        />
        <span header="Últimas plps geradas">
          <PLPsDownload />
        </span>
      </div>
    </div>
    <Action
      :items="items"
      :value="value"
      :loadTotalOrders="loadTotalOrders"
      :filters="filters"
      :filtro="filtro"
      :user="usr_orders"
      :listen_bus="listen_bus"
      :expedition="expedition"
    />
  </div>
</template>

<script>
import Action from "../Action.vue";
import barramento from "../../../../barramento";
import PLPsDownload from "../ActionMenuDropdown/PLPsDownload.vue";
export default {
  name: "ActionMenuDropdown",
  props: ["items", "usr_orders", "filters", "filtro", "expedition"],
  components: { Action, PLPsDownload },
  data() {
    return {
      value: null,
      listen_bus: "edit_option_status_entregue_",
      clickShowHide: false,
      loadTotalOrders: null,
      toggleLoadingActionsV2: false,
    };
  },
  methods: {
    funCclickShowHide() {
      this.clickShowHide = !this.clickShowHide;
    },
    optionStatusEntregue(action) {
      barramento.$emit(
        "edit_option_status_entregue_" + this.expedition,
        action
      );
      this.funCclickShowHide();
    },
  },
  beforeMount() {
    this.listen_bus = this.listen_bus + this.expedition;
  },
  beforeDestroy() {
    barramento.$off("action_props_totos");
    barramento.$off(`orders_load_nav_bar_${this.expedition}`);
  },
  created() {
    barramento.$on("action_props_totos", (objeto) => {
      this.value = objeto.value;
      this.loadTotalOrders = objeto.loadTotalOrders;
    });
    barramento.$on(`orders_load_nav_bar_${this.expedition}`, (status) => {
      this.toggleLoadingActionsV2 = status;
    });
  },
};
</script>

<style scoped>
.mainmenubtn {
  color: black;
  border: none;
  cursor: pointer;
}

.mainmenubtn:hover {
  background-color: #f8f9fa;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-child {
  background-color: #f8f9fa;
  min-width: 400px;
  position: absolute;
  left: 20px;
  top: 0px;
  z-index: 100;
  margin-top: 20px;
  border: none;
  padding: 8px;
  margin-top: 8px;
}

.dropdown-child a {
  color: black;
  padding: 8px;
  text-decoration: none;
  display: block;
  cursor: pointer;
}

.dropdown:hover .dropdown-child {
  display: block;
}

#id-do-elemento:hover {
  background-color: #e0e0e0;
  transition: 0.5s;
  opacity: 0.7;
}

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Orders_v2/Aggregates/ActionMenuDropdown/ActionMenuDropdown.vue